// Rechtliche Hinweise und AGB-Bestaetigung im Warenkorb (snippets/buechel-rechtliches-warenkorb.liquid).
// Alles per Ereignisdelegation am document: Horizon zeichnet Warenkorb und Schublade beim
// Aendern der Menge neu (morph), direkt gebundene Listener gingen dabei verloren.

if (!window.buechelRechtGeladen) {
  window.buechelRechtGeladen = true;

  const zeitstempel = () =>
    new Date().toLocaleString('de-DE', {
      timeZone: 'Europe/Berlin',
      dateStyle: 'medium',
      timeStyle: 'short',
    });

  /** Express-Zahlarten nicht bedienbar, solange die AGB nicht bestaetigt sind. */
  const expressSperren = (block) => {
    const express = block.nextElementSibling?.querySelector('.additional-checkout-buttons');
    if (express) express.inert = !block.classList.contains('is-accepted');
  };

  const alleBloecke = () => document.querySelectorAll('[data-buechel-recht]');

  const speichern = (schluessel, wert) =>
    fetch(`${window.Shopify?.routes?.root ?? '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [schluessel]: wert } }),
    }).catch(() => {
      // Kein Abbruch: Das versteckte Feld im Formular traegt den Wert beim Klick auf "Zur Kasse" mit.
    });

  const inhaltLaden = async (dialog) => {
    const ziel = dialog.querySelector('[data-buechel-inhalt]');
    if (!ziel || ziel.dataset.geladen) return;
    ziel.dataset.geladen = 'true';

    ziel.textContent = 'Wird geladen …';
    try {
      const antwort = await fetch(dialog.dataset.url);
      const html = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      const text = html.querySelector('.shopify-policy__body');
      if (!text) throw new Error('kein Richtlinientext');
      ziel.replaceChildren(...text.childNodes);
    } catch {
      delete ziel.dataset.geladen;
      ziel.innerHTML = '';
      const hinweis = document.createElement('p');
      hinweis.textContent = 'Der Text konnte nicht geladen werden. Bitte nutzen Sie den Link unten.';
      ziel.append(hinweis);
    }
  };

  document.addEventListener('click', (event) => {
    const oeffner = event.target.closest('[data-buechel-dialog]');
    if (oeffner) {
      event.preventDefault();
      const dialog = document.getElementById(oeffner.dataset.buechelDialog);
      if (!dialog) return;
      inhaltLaden(dialog);
      dialog.showModal();
      return;
    }

    if (event.target.closest('[data-buechel-schliessen]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    // Klick auf den abgedunkelten Hintergrund schliesst das Fenster.
    if (event.target instanceof HTMLDialogElement && event.target.matches('.buechel-recht__dialog')) {
      const r = event.target.getBoundingClientRect();
      const innen =
        event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!innen) event.target.close();
    }
  });

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('[data-buechel-agb]');
    if (!checkbox) return;

    const block = checkbox.closest('[data-buechel-recht]');
    const wert = checkbox.checked ? `Ja – bestätigt am ${zeitstempel()} Uhr` : '';

    // Seite und Schublade koennen gleichzeitig im DOM sein, beide gleich halten.
    for (const b of alleBloecke()) {
      b.classList.toggle('is-accepted', checkbox.checked);
      b.classList.remove('is-error');
      b.querySelector('[data-buechel-agb]').checked = checkbox.checked;
      b.querySelector('[data-buechel-agb-wert]').value = wert;
      b.querySelector('.buechel-recht__fehler').hidden = true;
      expressSperren(b);
    }

    speichern(block.dataset.attribut, wert);
  });

  // Kassen-Knopf abfangen (Capture-Phase, damit es vor dem Absenden greift).
  document.addEventListener(
    'click',
    (event) => {
      const knopf = event.target.closest('button[name="checkout"]');
      if (!knopf) return;

      let bereich = knopf.parentElement;
      while (bereich && !bereich.querySelector('[data-buechel-recht]')) bereich = bereich.parentElement;
      const block = bereich?.querySelector('[data-buechel-recht]');
      if (!block || block.querySelector('[data-buechel-agb]').checked) return;

      event.preventDefault();
      event.stopPropagation();
      block.classList.add('is-error');
      block.querySelector('.buechel-recht__fehler').hidden = false;
      const checkbox = block.querySelector('[data-buechel-agb]');
      checkbox.scrollIntoView({ block: 'center', behavior: 'smooth' });
      checkbox.focus({ preventScroll: true });
    },
    true
  );

  // Die Checkbox ist Pflichtfeld von #cart-form, damit der Browser das Absenden auch dann verhindert,
  // wenn dieses Script noch nicht geladen ist. Ist es geladen, ersetzt die eigene Meldung die Browser-Blase.
  document.addEventListener(
    'invalid',
    (event) => {
      const checkbox = event.target.closest?.('[data-buechel-agb]');
      if (!checkbox) return;
      event.preventDefault();
      const block = checkbox.closest('[data-buechel-recht]');
      block.classList.add('is-error');
      block.querySelector('.buechel-recht__fehler').hidden = false;
      checkbox.scrollIntoView({ block: 'center', behavior: 'smooth' });
      checkbox.focus({ preventScroll: true });
    },
    true
  );

  // Nach dem Neuzeichnen des Warenkorbs die Sperre der Express-Knoepfe wieder setzen.
  const beobachter = new MutationObserver(() => alleBloecke().forEach(expressSperren));
  beobachter.observe(document.body, { childList: true, subtree: true });
  alleBloecke().forEach(expressSperren);
}
